<template>
    <div type="card-full" class="card-full">
        <i class="el-icon-printer icon" v-if="isPrint" @click="print"></i>
        <div class="con-box">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'printView',
    data () {
        return {
            isPrint: true
        }
    },
    methods: {
        print () {
            this.isPrint = !this.isPrint
            setTimeout(() => {
                // this.isPrint =false
                 window.print()
            }, 300)
            setTimeout(() => {
                this.isPrint = !this.isPrint
            }, 500)
        }
    }
}
</script>
<style lang="scss" scoped>
.card-full{
    position: relative;
    width: 100%;
    height: 100%;
}
body{
    overflow-x: hidden;
}
.con-box{
    width: 90%;
    margin: 0 auto;
}
.icon {
    position: fixed;
    top: 20px;
    right: 200px;
    font-size: 46px;
    color: #fc5b2b;
    z-index: 999999;
    cursor: pointer;
}
</style>
